// Data Dummy untuk PANA Pejuang Digital

// Data 4 Wilayah Penugasan
export const wilayahData = [
  {
    id: 1,
    kabupaten: 'Sumedang',
    provinsi: 'Jawa Barat',
    jumlahSekolah: 50,
    kecamatan: 26,
    desa: 270,
  },
  {
    id: 2,
    kabupaten: 'Kupang',
    provinsi: 'Nusa Tenggara Timur',
    jumlahSekolah: 40,
    kecamatan: 24,
    desa: 160,
  },
  {
    id: 3,
    kabupaten: 'Halmahera Utara',
    provinsi: 'Maluku Utara',
    jumlahSekolah: 30,
    kecamatan: 17,
    desa: 126,
  },
  {
    id: 4,
    kabupaten: 'Merauke',
    provinsi: 'Papua Selatan',
    jumlahSekolah: 30,
    kecamatan: 22,
    desa: 179,
  },
]

// Data Tema Pendaftaran (dari Admin)
export const temaData = [
  {
    id: 1,
    nama: 'Digitalisasi Pembelajaran Matematika SD',
    deskripsi: 'Penerapan teknologi digital dalam pembelajaran matematika untuk siswa SD',
    aktif: true,
  },
  {
    id: 2,
    nama: 'Literasi Digital untuk Guru SD',
    deskripsi: 'Peningkatan kompetensi digital guru dalam proses pembelajaran',
    aktif: true,
  },
  {
    id: 3,
    nama: 'Pengembangan Konten Pembelajaran Interaktif',
    deskripsi: 'Pembuatan materi pembelajaran berbasis multimedia interaktif',
    aktif: true,
  },
]

// Data Timeline Program
export const timelineData = [
  {
    id: 1,
    judul: 'Pendaftaran & Seleksi',
    tanggal: '12 Februari - 6 Maret 2026',
    status: 'active',
  },
  {
    id: 2,
    judul: 'Pengumuman Hasil Seleksi',
    tanggal: '13 Maret 2026',
    status: 'upcoming',
  },
  {
    id: 3,
    judul: 'Pembekalan Peserta',
    tanggal: '26 Maret - 4 April 2026',
    status: 'upcoming',
  },
  {
    id: 4,
    judul: 'Penugasan (12 Minggu)',
    tanggal: '6 April - 21 Juni 2026',
    status: 'upcoming',
  },
  {
    id: 5,
    judul: 'Penarikan & Evaluasi',
    tanggal: '21 - 24 Juni 2026',
    status: 'upcoming',
  },
]

// Data Dummy User (untuk simulasi)
export const dummyUser = {
  id: 'USR-001',
  nama: 'Ahmad Fauzi',
  email: 'ahmad.fauzi@email.com',
  noHp: '081234567890',
  universitasAsal: 'Universitas Indonesia',
  jurusan: 'Pendidikan Matematika',
  tahunLulus: 2024,
}

// Data Dummy Pendaftaran
export const dummyPendaftaran = {
  id: 'PJD-2026-00123',
  userId: 'USR-001',
  temaId: 1,
  tema: 'Digitalisasi Pembelajaran Matematika SD',
  judul: 'Implementasi Aplikasi Pembelajaran Matematika Interaktif untuk SD di Daerah 3T',
  essay: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
  suratIzinKerja: 'surat_izin_kerja.pdf',
  suratPernyataan: 'surat_pernyataan.pdf',
  status: 'approved', // draft, submitted, approved, rejected
  tanggalDaftar: '2026-02-20',
}

// Data Dummy Hasil Seleksi
export const dummyHasilSeleksi = {
  id: 'HSL-001',
  pendaftaranId: 'PJD-2026-00123',
  hadir: true,
  skorPsikotest: 85,
  skorWawasanKebangsaan: 78,
  skorTotal: 163,
  statusLulus: true,
}

// Data Dummy Penempatan
export const dummyPenempatan = {
  id: 'PNP-001',
  pendaftaranId: 'PJD-2026-00123',
  wilayahId: 1,
  wilayah: 'Sumedang',
  provinsi: 'Jawa Barat',
  namaSekolah: 'SDN 01 Tanjungsari',
  tanggalMulai: '2026-04-06',
  tanggalSelesai: '2026-06-21',
  suratPenugasan: 'sp_pjd_2026_00123.pdf',
  mingguKe: 2, // Progress minggu saat ini
}

// Data Dummy Monev Mingguan
export const dummyMonevData = [
  {
    mingguKe: 1,
    tanggalMulai: '2026-04-06',
    tanggalSelesai: '2026-04-12',
    laporan: 'Minggu pertama berjalan lancar. Melakukan orientasi di sekolah dan bertemu dengan guru-guru.',
    file: 'monev_minggu_1.pdf',
    status: 'completed',
  },
  {
    mingguKe: 2,
    tanggalMulai: '2026-04-13',
    tanggalSelesai: '2026-04-19',
    laporan: 'Mulai melakukan asesmen kemampuan digital guru.',
    file: 'monev_minggu_2.pdf',
    status: 'completed',
  },
  {
    mingguKe: 3,
    tanggalMulai: '2026-04-20',
    tanggalSelesai: '2026-04-26',
    laporan: '',
    file: '',
    status: 'active',
  },
  {
    mingguKe: 4,
    tanggalMulai: '2026-04-27',
    tanggalSelesai: '2026-05-03',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 5,
    tanggalMulai: '2026-05-04',
    tanggalSelesai: '2026-05-10',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 6,
    tanggalMulai: '2026-05-11',
    tanggalSelesai: '2026-05-17',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 7,
    tanggalMulai: '2026-05-18',
    tanggalSelesai: '2026-05-24',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 8,
    tanggalMulai: '2026-05-25',
    tanggalSelesai: '2026-05-31',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 9,
    tanggalMulai: '2026-06-01',
    tanggalSelesai: '2026-06-07',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 10,
    tanggalMulai: '2026-06-08',
    tanggalSelesai: '2026-06-14',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 11,
    tanggalMulai: '2026-06-15',
    tanggalSelesai: '2026-06-21',
    laporan: '',
    file: '',
    status: 'locked',
  },
  {
    mingguKe: 12,
    tanggalMulai: '2026-06-22',
    tanggalSelesai: '2026-06-28',
    laporan: '',
    file: '',
    status: 'locked',
  },
]

// Data Dummy Logbook
export const dummyLogbookData = [
  {
    id: 1,
    judul: 'Pelatihan Penggunaan Google Classroom',
    tanggal: '2026-04-10',
    linkVideo: 'https://www.youtube.com/watch?v=example1',
    linkDokumen: 'https://drive.google.com/file/d/example1',
    status: 'reviewed',
  },
  {
    id: 2,
    judul: 'Workshop Pembuatan Konten Digital',
    tanggal: '2026-04-15',
    linkVideo: 'https://www.youtube.com/watch?v=example2',
    linkDokumen: '',
    status: 'pending',
  },
]

// FAQ Data
export const faqData = [
  {
    id: 1,
    pertanyaan: 'Apa itu PANA Alumni Pejuang Digital?',
    jawaban: 'PANA Alumni Pejuang Digital adalah program kolaborasi Kemendikdasmen dan LPDP untuk mempercepat digitalisasi pembelajaran di wilayah 3T dan Daerah Khusus. Alumni LPDP berperan sebagai Pejuang Digital yang mendampingi guru selama 12 minggu secara intensif.',
  },
  {
    id: 2,
    pertanyaan: 'Siapa saja yang bisa mendaftar?',
    jawaban: 'Minimal alumni jenjang S2 dari semua jurusan yang bersedia ditempatkan di seluruh lokasi penugasan selama 12 minggu.',
  },
  {
    id: 3,
    pertanyaan: 'Apa saja dokumen yang perlu disiapkan?',
    jawaban: 'Dokumen yang diperlukan: Surat Izin Bekerja dari instansi (jika bekerja) dan Surat Pernyataan kesediaan mengikuti program.',
  },
  {
    id: 4,
    pertanyaan: 'Bagaimana proses seleksi dilakukan?',
    jawaban: 'Proses seleksi meliputi: seleksi administrasi, tes psikotest, tes wawasan kebangsaan, dan penentuan kelulusan berdasarkan skor total.',
  },
  {
    id: 5,
    pertanyaan: 'Apa fasilitas yang diberikan?',
    jawaban: 'Peserta akan mendapatkan: biaya hidup selama penugasan, akomodasi, transportasi, dan sertifikat pengabdian.',
  },
]
